/*
 * "Sua discussão é semelhante a…" — enquanto a pessoa escreve o título de um
 * tópico novo, o tema procura tópicos parecidos e os mostra num balão ao
 * lado do composer, para evitar a pergunta repetida.
 *
 * A busca começa com três palavras ou mais e espera a pessoa parar de digitar.
 * O balão some quando ela o fecha (até o título mudar de novo de verdade) ou
 * quando não há resultados.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import { debounce } from 'flarum/common/utils/throttleDebounce';
import { composerOn } from './common';
import { discussionBadges } from '../../utils/tags';
import { shortAge, fullDate } from '../../utils/dates';
import { t } from '../../utils/settings';
const MIN_WORDS = 3;
const LIMIT = 5;
const WAIT_MS = 700;
function normalizeTitle(title) {
  return title.trim().replace(/\s+/g, ' ').toLowerCase();
}
export default function installSimilarTopics() {
  extend('flarum/forum/components/DiscussionComposer', 'oninit', function () {
    let request = 0;
    const state = {
      title: '',
      searched: '',
      results: [],
      dismissedFor: null,
      search: debounce(WAIT_MS, title => {
        const current = ++request;
        app.store.find('discussions', {
          filter: {
            q: title
          },
          page: {
            limit: LIMIT
          }
        }, undefined, {
          errorHandler: () => {}
        }).then(results => {
          // Uma busca mais nova já saiu: esta resposta chegou atrasada.
          if (current !== request) return;
          state.results = Array.from(results);
          m.redraw();
        }).catch(() => {});
      })
    };
    this.canelaSimilar = state;
  });
  extend('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    const state = this.canelaSimilar;
    if (!state || !composerOn('Similar')) return;

    // O headerItems roda a cada redesenho, e cada tecla no título redesenha:
    // é aqui que a mudança do título é percebida.
    const title = normalizeTitle(this.title?.() || '');
    if (title !== state.title) {
      state.title = title;
      if (title.split(' ').filter(Boolean).length >= MIN_WORDS) {
        if (title !== state.searched) {
          state.searched = title;
          state.search(title);
        }
      } else {
        state.results = [];
        state.searched = '';
      }
    }
    const minimized = app.composer.position === 'minimized';
    if (minimized || !state.results.length || state.dismissedFor === state.searched) return;
    items.add('canelaSimilar', m("div", {
      className: "CanelaSimilarTopics",
      role: "region",
      "aria-label": t('composer.similar.title')
    }, m("div", {
      className: "CanelaSimilarTopics-header"
    }, m("h4", {
      className: "CanelaSimilarTopics-title"
    }, t('composer.similar.title')), m("button", {
      type: "button",
      className: "Button Button--icon Button--link CanelaSimilarTopics-close",
      "aria-label": t('composer.similar.close'),
      title: t('composer.similar.close'),
      onclick: () => state.dismissedFor = state.searched
    }, m(Icon, {
      name: "fas fa-xmark"
    }))), m("ul", {
      className: "CanelaSimilarTopics-list"
    }, state.results.map(discussion => m("li", {
      key: discussion.id()
    }, m(Link, {
      className: "CanelaSimilarTopics-item",
      href: app.route.discussion(discussion)
      // O composer fica aberto na troca de página (é do app, não da
      // página); minimizado, a pessoa lê o tópico e volta a ele.
      ,
      onclick: () => app.composer.minimize()
    }, m("span", {
      className: "CanelaSimilarTopics-itemTitle"
    }, discussion.title()), m("span", {
      className: "CanelaSimilarTopics-itemMeta"
    }, discussionBadges(discussion, false), m("span", {
      className: "CanelaSimilarTopics-itemStats",
      title: fullDate(discussion.lastPostedAt() || discussion.createdAt())
    }, m(Icon, {
      name: "far fa-comment"
    }), " ", discussion.replyCount(), " \xB7 ", shortAge(discussion.lastPostedAt() || discussion.createdAt())))))))), -100);
  });
}
flarum.reg.add('ramon-canela', 'forum/features/composer/installSimilarTopics', installSimilarTopics);